'use client';

import { ClubCoinAmount } from '@wwe-portal/ui/features/club-store';

import React from 'react';
import { useSubscriptionHistory } from '@wwe-portal/web/utils/club-store/helper';
import { useGetClubCoins } from '@wwe-portal/web/providers/queries/currency';

export const ClubCoinBalance = () => {
  const { amount: currentUserClubCoin } = useGetClubCoins();
  const { goAddClubCoin } = useSubscriptionHistory();
  if (currentUserClubCoin == null) return null;
  return (
    <div>
      <ClubCoinAmount
        clubCoin={currentUserClubCoin}
        onClickAdd={goAddClubCoin}
      />
    </div>
  );
};
